import React from "react";
import TasksPage from "..";

export default function MyTasksDeskPage() {
  return <TasksPage mode="mine" />;
}
